import * as Sentry from '@sentry/react';

export function initSentry() {
    const dsn = import.meta.env.VITE_SENTRY_DSN;
    const isProduction = import.meta.env.VITE_APP_ENV === 'production';

    if (!isProduction || !dsn) {
        return;
    }

    Sentry.init({
        dsn,
        environment: import.meta.env.VITE_APP_ENV,
        tracesSampleRate: 0.2,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration()
        ],
        maxBreadcrumbs: 50,
        attachStacktrace: true,
        ignoreErrors: [
            'top.GLOBALS',
            'mozAccessible is not defined',
            'NetworkError',
            'Network request failed',
        ],
    });
}

export default Sentry;
